// @ts-nocheck
import { Box, Button, Typography } from '@mui/material';
import React from 'react';

const ClearSelection = ({ handleClear }) => {
  const clearButtonStyle = {
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  };
  const clearTextStyle = {
    color: '#F0841F',
    marginTop: 5,
  };
  return (
    <Box align="right" mt={1}>
      <Button
        variant="text"
        sx={clearButtonStyle}
        onClick={handleClear}
        size="small"
        disableRipple
      >
        <Typography variant="subtitle2" style={clearTextStyle}>
          Clear selection
        </Typography>
      </Button>
    </Box>
  );
};

export default ClearSelection;
